import React from 'react';
import {CrowImage, CrownOptimMp4, CrownOptimWebm} from "../../FlowMedia";


class AboutLanding extends React.Component {


    render() {

        return (
            <div className="_ie-flex-min-height-fix" >
                <section className="o-section-full o-section--below-nav about-landing" >
                    <div className="u-width-limiter" >
                        <div className="c-section-video-fill-wrapper" >
                            <video autoPlay loop="loop" muted poster={CrowImage} data-load-time-perc="auto" >
                                <source src={CrownOptimWebm} type="video/webm"  />
                                <source src={CrownOptimMp4} type="video/mp4"  />
                            </video>
                        </div>
                        <header className="about-landing__content" >
                            <h6 className="type-subheadlines-buttons" >We are Ideanix.</h6><span className="type-intro-headline" >Strategically obsessed,</span><span className="type-intro-headline" >creatively inspired,</span><span className="type-intro-headline" >audaciously ambitious,</span><span className="type-intro-headline" >consumer centric,</span><span className="type-intro-headline" >digital natives.</span>
                            <hr className="c-hr c-hr--yellow c-hr--large"  />
                        </header>
                    </div>
                </section>
            </div>
        )
    }
}

export default (AboutLanding);
